import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
type NextLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const NextLogo: React.FC<NextLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "Next.js logo";
    t9 = cn("stroke-black dark:stroke-white", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16572)"><path d="M12.0001 20.0005V12.0005L22.3268 26.2005C19.7713 27.7878 16.7129 28.3573 13.7573 27.7963C10.8017 27.2353 8.16472 25.5846 6.36863 23.1713C4.57253 20.758 3.74839 17.7581 4.05948 14.7659C4.37057 11.7737 5.79418 9.00753 8.0483 7.0153C10.3024 5.02308 13.2226 3.95018 16.2304 4.00914C19.2381 4.06811 22.114 5.25464 24.2883 7.33368C26.4626 9.41273 27.7767 12.2326 27.9703 15.2347C28.1639 18.2368 27.2228 21.2021 25.3335 23.5431" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M20 16V12" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16572"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};